function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="56" height="56" viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg" {...props}><g fill="none" fillRule="evenodd"><rect fill="#00BD83" width="56" height="56" rx="10" /><path d="M22 19a1 1 0 0 1 1.54-.841l14 9a1 1 0 0 1 0 1.682l-14 9A1 1 0 0 1 22 37V19zm2 1.832v14.336L35.15 28 24 20.832z" fill="#FFF" fillRule="nonzero" /></g></svg>;
});